import React from "react";
import { useTranslation } from "react-i18next";
import ourValuesData from "../data/ourValuesData";

export default function OurValues() {
  const { t } = useTranslation();

  const showData = ourValuesData.map((el, index) => {
    return (
      <div key={index} className="flex flex-col items-center text-center justify-center gap-3 shadow-[0px_0px_10px_#00000038] rounded-lg p-5 h-[200px]">
        <div>
          <img src={el.icon} alt={el.title} className="w-12 h-12" />
        </div>
        <div>
          <div className="text-lg font-semibold">{t(el.title)}</div>
          <p className="text-sm text-gray-600">{t(el.details)}</p>
        </div>
      </div>
    );
  });

  return <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">{showData}</div>;
}
